var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeBtnIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16.6667,
    fill: "#03002F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7989 17.184C24.5236 16.9366 24.1665 16.7998 23.7964 16.7998C23.4263 16.7998 23.0692 16.9366 22.7939 17.184L17.2939 22.126C17.1375 22.2666 17.0124 22.4386 16.9268 22.6307C16.8412 22.8228 16.7969 23.0307 16.7969 23.241V30.296C16.7969 30.6938 16.9549 31.0754 17.2362 31.3567C17.5175 31.638 17.8991 31.796 18.2969 31.796H20.2969C20.6947 31.796 21.0762 31.638 21.3575 31.3567C21.6388 31.0754 21.7969 30.6938 21.7969 30.296V26.296C21.7969 26.1634 21.8496 26.0362 21.9433 25.9425C22.0371 25.8487 22.1643 25.796 22.2969 25.796H25.2969C25.4295 25.796 25.5567 25.8487 25.6504 25.9425C25.7442 26.0362 25.7969 26.1634 25.7969 26.296V30.296C25.7969 30.6938 25.9549 31.0754 26.2362 31.3567C26.5175 31.638 26.8991 31.796 27.2969 31.796H29.2969C29.6947 31.796 30.0762 31.638 30.3575 31.3567C30.6388 31.0754 30.7969 30.6938 30.7969 30.296V23.241C30.7968 23.0307 30.7526 22.8228 30.6669 22.6307C30.5813 22.4386 30.4563 22.2666 30.2999 22.126L24.7999 17.184H24.7989Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeBtnIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/homeBtnIcon.3e3a839ec31874cc12c85991d53b4e3c.svg";